import { render, staticRenderFns } from "./CPAlertsEdit.vue?vue&type=template&id=36ce9cc2&scoped=true&"
import script from "./CPAlertsEdit.vue?vue&type=script&lang=ts&"
export * from "./CPAlertsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CPAlertsEdit.vue?vue&type=style&index=0&id=36ce9cc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce9cc2",
  null
  
)

export default component.exports